var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "lds-ring",
      class: { visible: _vm.isVisible, half: _vm.half }
    },
    [_c("div"), _c("div"), _c("div"), _c("div")]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44a800b0", { render: render, staticRenderFns: staticRenderFns })
  }
}